import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import {Status} from "../../common/Constants";

class MasterBankFilter extends Component {
    statusOptions = [
        {
            label: Status.ACTIVE,
            value: Status.ACTIVE,
        },
        {
            label: Status.INACTIVE,
            value: Status.INACTIVE,
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            cabangOptions: [],
        };
    }

    componentDidMount() {
        this.setState((prevValue) => ({
            ...prevValue,
            cabangOptions: this.props.state.cabangRawOptions,
        }));
    }

    handleValueChange = (name, value) => {
        this.props.onSetState((prevParentState) => ({
            ...prevParentState,
            filterData: {
                ...prevParentState.filterData,
                [name]: value,
            },
        }));
    };

    getFilterDataValue = (fieldName, fallbackValue = "") => {
        const defaultValue = fieldName === "kodecabang" ? [] : fallbackValue;
        return !R.isNil(this.props.state.filterData) &&
        this.props.state.filterData[fieldName]
            ? this.props.state.filterData[fieldName]
            : defaultValue;
    };

    getLabelForValue = (value, options) => {
        const match = options.find((option) => option.value === value);
        return match ? match.label : value;
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.state.isFilterModalsVisible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <SimpleInput
                            id="input_text_kode_bank"
                            name="bankid"
                            label="ID"
                            value={this.getFilterDataValue("bankid")}
                            onChange={({target}) =>
                                this.handleValueChange(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_nama_bank"
                            name="bankname"
                            label="Nama Bank"
                            value={this.getFilterDataValue("bankname")}
                            onChange={({target}) =>
                                this.handleValueChange(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_no_rekening"
                            name="bankaccountno"
                            label="Nomor Rekening"
                            value={this.getFilterDataValue("bankaccountno")}
                            onChange={({target}) =>
                                this.handleValueChange(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_nama_rekening"
                            name="bankaccountname"
                            label="Nama Rekening"
                            value={this.getFilterDataValue("bankaccountname")}
                            onChange={({target}) =>
                                this.handleValueChange(target.name, target.value)
                            }
                        />
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            name="kodecabang"
                            label="Nama Cabang"
                            box="multiselect"
                            isClearable
                            options={this.state.cabangOptions} // Daftar opsi dengan label dan value
                            value={this.getFilterDataValue("kodecabang", null)}
                            onChange={(selectedOptions, {name}) =>
                                this.handleValueChange(
                                    name,
                                    selectedOptions
                                )
                            }
                        />

                        <SimpleDDL
                            id="input_text_status"
                            name="status"
                            label="Status"
                            box="search"
                            isClearable
                            options={this.statusOptions}
                            value={
                                this.props.state.filterData?.status
                                    ? this.statusOptions.find(
                                    (option) => option.value === this.props.state.filterData.status
                                ) || null
                                    : null
                            }
                            onChange={(value, {name}) => {
                                this.handleValueChange(name, value ? value.value : null);
                            }}
                        />
                        <FlexView hAlignContent="center">
                            <SimpleButton
                                type="button"
                                secondary
                                onClick={this.props.onReset}
                            >
                                Hapus
                            </SimpleButton>
                            <SimpleButton type="button" onClick={this.props.onSubmit}>
                                Terapkan
                            </SimpleButton>
                        </FlexView>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterBankFilter;
